import FormattedInput from './FormattedInput'

export * from './FormattedInput'
export default FormattedInput
